"use client"
import { useTheme } from "@mui/material/styles"
import { FC } from "react"

import styles from "./PostHeaderAuthor.module.scss"

import { PostItemAuthor } from "@/components/common/post-item/PostItemAuthor"

import { create } from "@/helpers/bem"
import { resolveDarkModeAsset } from "@/helpers/theme"

import {
  UploadFileEntityResponse,
  AuthorEntityResponse,
} from "@/types/generated/strapi/graphql"

const bem = create(styles, "PostHeaderAuthor")

export type PostHeaderAuthorProps = {
  authorsBio?: AuthorEntityResponse
}

export const PostHeaderAuthor: FC<PostHeaderAuthorProps> = ({ authorsBio }) => {
  const theme = useTheme()
  const author = authorsBio?.data?.attributes
  const authorAvatar = author?.avatar?.data?.attributes
  return (
    <PostItemAuthor
      className={bem()}
      name={author?.name}
      avatar={{
        src:
          resolveDarkModeAsset(
            theme,
            author?.avatar as UploadFileEntityResponse,
          ) ?? undefined,
        alt: authorAvatar?.alternativeText ?? "",
      }}
      avatarProps={{
        size: "xs",
      }}
      nameProps={{
        className: bem("name"),
      }}
    />
  )
}
